import React from "react";
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Controller } from "react-hook-form";
import BaseInput from "components/shared/baseForm/BaseInput";
import { REQUIRED_ERROR } from "utils/errorMessages";

export default function OtherOrder({
  control,
  errors,
  guestBillingTypeId,
  chargesByType,
}) {
  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ marginBottom: "20px" }}>
        <Grid size={8}>
          <BaseInput
            id="guestName"
            control={control}
            errors={errors}
            name="guestName"
            type="text"
            placeholder="Enter Name"
            validationProps={{
              required: REQUIRED_ERROR("Name"),
              maxLength: {
                value: 50,
                message: "Name cannot be over 50 characters",
              },
            }}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
            InputProps={{
              startAdornment: (
                <Typography
                  component="span"
                  sx={{ color: "#666", marginRight: "8px" }}>
                  🔍
                </Typography>
              ),
            }}
          />
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ marginBottom: "20px" }}>
        <Grid size={3}>
          <Typography sx={{ textAlign: "right", fontWeight: "500" }}>
            Other Charge:
          </Typography>
        </Grid>
        <Grid size={3}>
          <Controller
            name="guestBillingTypeId"
            control={control}
            defaultValue={guestBillingTypeId ?? 0}
            rules={{
              required: REQUIRED_ERROR("Other Charge"),
              validate: (value) => value !== 0 || REQUIRED_ERROR("Charge Type"),
            }}
            render={({ field, fieldState: { error } }) => (
              <FormControl fullWidth error={!!error}>
                <Select
                  {...field}
                  value={field.value ?? 0}
                  onChange={(e) => field.onChange(Number(e.target.value))}
                  id="guestBillingTypeId"
                  variant="outlined"
                  size="small"
                  fullWidth
                  displayEmpty
                  sx={{
                    borderRadius: "8px",
                  }}
                >
                  <MenuItem value={0} disabled>
                    Select Charge
                  </MenuItem>
                  {chargesByType?.map((charge) => {
                    return (
                      <MenuItem key={charge.id} value={charge.id}>
                        {charge.chargeText}
                      </MenuItem>
                    );
                  })}
                </Select>
                {error && <FormHelperText>{error.message}</FormHelperText>}
              </FormControl>
            )}
          />
        </Grid>
      </Grid>
    </>
  );
}
